import React from "react";

const Footer = () => {
  return (
    <div className={`p-3 text-center`} style={{backgroundColor: `#A11313`, color: "#fff"}}>
     Footer
    </div>
  );
};

export default Footer;
